import { render, staticRenderFns } from "./userDocuments.vue?vue&type=template&id=9528d6a8"
import script from "./userDocuments.vue?vue&type=script&lang=js"
export * from "./userDocuments.vue?vue&type=script&lang=js"
import style0 from "./userDocuments.vue?vue&type=style&index=0&id=9528d6a8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports